module.exports = __webpack_public_path__ + "static/media/static.1a79e3da.svg";